import { GRAPH_NAMES } from '../../../../../store/dashboard/constants';
import {
    complianceStatusUnavailable as statusUnavailable,
    complianceStatusOk as statusOk,
    complianceStatusDelayed as statusDelayed,
    complianceStatusDefault as statusDefault,
} from '../../../../../assets/hostedassets';

export const FILING_GRAPH_NAMES = new Set<string>([GRAPH_NAMES.GSTR1_FILING_STATUS, GRAPH_NAMES.GSTR3B_FILING_STATUS]);

/** Cards drawn as Apr→Mar financial-year rows instead of calendar years. */
export const FY_GRID_GRAPH_NAMES = new Set<string>([...FILING_GRAPH_NAMES, GRAPH_NAMES.EPF_COMPLIANCE]);

export const FY_GRID_LEGEND = [
    { img: statusUnavailable, label: 'Filing Unavailable' },
    { img: statusOk, label: 'On time' },
    { img: statusDelayed, label: 'Delayed' },
    { img: statusDefault, label: 'Default' },
];

/** FY-grid icon per status (`yValue`); delayed months render a day count instead, the rest are unavailable. */
export const FY_GRID_STATUS_ICONS: Record<number, string> = { 1: statusOk, 3: statusDefault };
